@if (
  (userStore.initialized() && userStore.isLoggedIn()) ||
  userStore.context() === 'atlasExternal' ||
  userStore.context() === 'guestView'
) {
  <app-authenticated-atlas></app-authenticated-atlas>
} @else if (!userStore.initialized()) {
  <app-atlas-loading-skeleton />
}
